import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { AuthLayout } from "@/components/AuthLayout";
import { Button } from "@/components/ui/button";
import { Loader2, CheckCircle2, XCircle } from "lucide-react";

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!token) { setStatus("error"); return; }
    api.post("/auth/verify-email", { token })
      .then(() => setStatus("ok"))
      .catch(() => setStatus("error"));
  }, [token]);

  return (
    <AuthLayout title="Verifica email" subtitle="Conferma del tuo indirizzo email">
      <div className="flex flex-col items-center gap-4 py-6 text-center" data-testid="verify-email">
        {status === "loading" && <Loader2 className="h-10 w-10 animate-spin text-primary" />}
        {status === "ok" && (
          <>
            <CheckCircle2 className="h-14 w-14 text-primary" />
            <p className="text-sm text-muted-foreground">La tua email è stata verificata con successo.</p>
            <Link to="/dashboard"><Button className="rounded-lg">Vai alla dashboard</Button></Link>
          </>
        )}
        {status === "error" && (
          <>
            <XCircle className="h-14 w-14 text-destructive" />
            <p className="text-sm text-muted-foreground">Link di verifica non valido o scaduto.</p>
            <Link to="/login"><Button variant="outline" className="rounded-lg">Torna al login</Button></Link>
          </>
        )}
      </div>
    </AuthLayout>
  );
}
